module.exports = __webpack_public_path__ + "media/icons/donut-chart-3b18f5fc.png";